module.exports = __webpack_public_path__ + "img/yuangongpingji.f56bb686.png";